(function () {
  function initMobileMenuToggle() {
    if (!window.matchMedia('(max-width: 992px)').matches || !window.jQuery) return;

    var $ = window.jQuery;
    var $hamburgers = $('.hamburger');
    if (!$hamburgers.length) return;

    // essentials.js registers a direct, un-namespaced click handler on the
    // hamburger. Remove that legacy binding first so one tap can only change
    // the menu state once, even if the header/scripts have been initialized
    // more than once.
    $hamburgers.off('click');

    $hamburgers.on('click.goyuMobileMenu', function (event) {
      event.preventDefault();
      event.stopPropagation();

      var shouldOpen = !this.classList.contains('is-active');

      $('html').toggleClass('is-active', shouldOpen);
      $('body').toggleClass('is-active', shouldOpen);
      $(this).toggleClass('is-active', shouldOpen);
      $('.nav__mobile-menu').toggleClass('is-active', shouldOpen);
      $('.nav__moverlay').toggleClass('is-active', shouldOpen);
      $(this).closest('.nav__mobilemenu').attr('aria-expanded', shouldOpen ? 'true' : 'false');
    });
  }

  initMobileMenuToggle();
  document.addEventListener('shopify:section:load', initMobileMenuToggle);

  // Mobile accordion: keep one level-1 group open. Browsers that support
  // <details name> do this themselves; this covers older ones.
  document.addEventListener('toggle', function (event) {
    var group = event.target;
    if (!group.classList || !group.classList.contains('nav__macc-group') || !group.open) return;
    document.querySelectorAll('.nav__macc-group[open]').forEach(function (other) {
      if (other !== group) other.open = false;
    });
  }, true);

  if (window.matchMedia('(max-width: 992px)').matches) return;

  document.querySelectorAll('.nav__mega-menu').forEach(function (menu) {
    var handle = menu.dataset.megaHandle;
    var menuItem = document.querySelector('.nav__menu-item--mega[data-mega-handle="' + handle + '"]');
    var closeTimer;

    // Onzichtbare brug over de ruimte tussen het hoofditem en het menu, zodat
    // het menu open blijft als de cursor er langzaam of schuin doorheen gaat.
    function sizeBridge() {
      if (!menuItem) return;
      var itemRect = menuItem.getBoundingClientRect();
      var menuRect = menu.getBoundingClientRect();
      menuItem.style.setProperty('--mega-bridge-height', Math.max(0, menuRect.top - itemRect.bottom) + 'px');
      menuItem.style.setProperty('--mega-bridge-left', (menuRect.left - itemRect.left) + 'px');
      menuItem.style.setProperty('--mega-bridge-width', menuRect.width + 'px');
    }

    function openMenu() {
      clearTimeout(closeTimer);
      sizeBridge();
      if (menuItem) menuItem.classList.add('is-open');
      menu.classList.add('is-open');
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        if (!menu.matches(':hover') && !(menuItem && menuItem.matches(':hover')) && !menu.contains(document.activeElement)) {
          if (menuItem) menuItem.classList.remove('is-open');
          menu.classList.remove('is-open');
        }
      }, 300);
    }

    if (menuItem) {
      menuItem.addEventListener('mouseenter', openMenu);
      menuItem.addEventListener('mouseleave', scheduleClose);
      menuItem.addEventListener('focusin', openMenu);
      menuItem.addEventListener('focusout', scheduleClose);
    }

    menu.addEventListener('mouseenter', openMenu);
    menu.addEventListener('mouseleave', scheduleClose);
    menu.addEventListener('focusin', openMenu);
    menu.addEventListener('focusout', scheduleClose);

    function showPanel(tab) {
      if (tab.classList.contains('is-active')) return;
      var tabHandle = tab.dataset.tabHandle;

      menu.querySelectorAll('.nav__mega-sidebar-tab').forEach(function (t) {
        t.classList.toggle('is-active', t === tab);
        if (t.tagName === 'BUTTON') t.setAttribute('aria-expanded', t === tab ? 'true' : 'false');
      });

      menu.querySelectorAll('.nav__mega-panel').forEach(function (panel) {
        panel.classList.toggle('is-active', panel.dataset.tabPanel === tabHandle);
      });
    }

    menu.querySelectorAll('.nav__mega-sidebar-tab').forEach(function (tab) {
      // Hover of focus wisselt het paneel. Een tab die een link is (Bestsellers,
      // Sale) gaat bij klikken naar de collectie; een knop wisselt alleen.
      tab.addEventListener('mouseenter', function () { showPanel(tab); });
      tab.addEventListener('focus', function () { showPanel(tab); });
      if (tab.tagName === 'BUTTON') {
        tab.addEventListener('click', function () { showPanel(tab); });
      }
    });
  });

  document.querySelectorAll('.nav__menu-item--mega[data-mega-handle]').forEach(function (item) {
    var handle = item.dataset.megaHandle;
    var style = document.createElement('style');
    style.textContent =
      '@media (min-width:993px){' +
      '.nav__holder:has(.nav__menu-item--mega[data-mega-handle="' + handle + '"]:hover) .nav__mega-menu[data-mega-handle="' + handle + '"],' +
      '.nav__holder:has(.nav__mega-menu[data-mega-handle="' + handle + '"]:hover) .nav__mega-menu[data-mega-handle="' + handle + '"],' +
      '.nav__menu-item--mega[data-mega-handle="' + handle + '"].is-open + *, .nav__mega-menu[data-mega-handle="' + handle + '"].is-open{' +
      'opacity:1;visibility:visible;pointer-events:auto}' +
      '}';
    document.head.appendChild(style);
  });
})();
